const translations = {
  pt: {
    nav: {
      home: "Início",
      menu: "Ementa",
      location: "Localização",
      reserve: "Reservar Mesa",
      admin: "Admin"
    },
    hero: {
      cta: "Reservar Mesa",
      menuBtn: "Ver Ementa",
      scroll: "Descobrir"
    },
    about: {
      badge: "— Restaurante —",
      avgPrice: "Preço médio",
      cuisine: "Cozinha Mediterrânica",
      location: "Portimão, Algarve"
    },
    menu: {
      title: "A Nossa Ementa",
      badge: "— Gastronomia —",
      subtitle: "Sabores que celebram o Mediterrâneo",
      viewAll: "Ver Ementa Completa",
      available: "Disponível",
      unavailable: "Indisponível",
      noImage: "Fotografia em breve"
    },
    gallery: {
      title: "Galeria",
      badge: "— Momentos —",
      subtitle: "A nossa história em imagens",
      empty: "Galeria em breve"
    },
    location: {
      title: "Encontre-nos",
      badge: "— Localização —",
      address: "Morada",
      hours: "Horários",
      contact: "Contactos",
      directions: "Como Chegar",
      call: "Ligar Agora",
      reserve: "Reservar Mesa"
    },
    footer: {
      rights: "Todos os direitos reservados",
      reserve: "Reservar Mesa",
      links: "Links",
      contact: "Contactos",
      social: "Redes Sociais"
    },
    admin: {
      login: "Entrar no Painel",
      email: "Email",
      password: "Password",
      loginBtn: "Entrar",
      loggingIn: "A entrar...",
      logout: "Sair",
      dashboard: "Painel",
      content: "Conteúdo",
      menu: "Ementa",
      gallery: "Galeria",
      settings: "Configurações",
      save: "Guardar",
      saving: "A guardar...",
      saved: "Guardado!",
      cancel: "Cancelar",
      add: "Adicionar",
      edit: "Editar",
      delete: "Eliminar",
      upload: "Enviar imagem",
      uploading: "A enviar...",
      confirmDelete: "Tem a certeza que deseja eliminar?",
      portuguese: "Português",
      english: "Inglês",
      heroSection: "Secção Hero",
      aboutSection: "Sobre o Restaurante",
      heroTitle: "Título Hero",
      heroSubtitle: "Subtítulo Hero",
      heroImage: "Imagem Hero",
      aboutTitle: "Título Sobre",
      aboutText: "Texto Sobre",
      aboutImage: "Imagem Sobre",
      categories: "Categorias",
      dishes: "Pratos",
      categoryName: "Nome da Categoria",
      dishName: "Nome do Prato",
      description: "Descrição",
      price: "Preço (€)",
      category: "Categoria",
      available: "Disponível",
      featured: "Destaque",
      dishImage: "Fotografia do Prato",
      addCategory: "Nova Categoria",
      addDish: "Novo Prato",
      editCategory: "Editar Categoria",
      editDish: "Editar Prato",
      address: "Morada",
      phone: "Telefone",
      email: "Email",
      hours: "Horários",
      reservationUrl: "Link de Reservas",
      mapsEmbed: "URL Google Maps (embed)",
      logoHeader: "Logótipo Header",
      logoFooter: "Logótipo Footer",
      socialFacebook: "Facebook URL",
      socialInstagram: "Instagram URL",
      socialTripadvisor: "TripAdvisor URL",
      seoTitle: "Título SEO",
      seoDescription: "Descrição SEO",
      seoKeywords: "Palavras-chave SEO",
      contactInfo: "Informações de Contacto",
      socialMedia: "Redes Sociais",
      seoSettings: "SEO",
      logos: "Logótipos",
      stats: "Estatísticas",
      totalDishes: "Pratos",
      totalCategories: "Categorias",
      totalGallery: "Galeria",
      welcomeBack: "Bem-vindo de volta",
      imageCaption: "Legenda (opcional)",
      order: "Ordem",
      galleryCaption: "Legenda da Imagem"
    }
  },
  en: {
    nav: {
      home: "Home",
      menu: "Menu",
      location: "Location",
      reserve: "Book a Table",
      admin: "Admin"
    },
    hero: {
      cta: "Book a Table",
      menuBtn: "View Menu",
      scroll: "Discover"
    },
    about: {
      badge: "— Restaurant —",
      avgPrice: "Average price",
      cuisine: "Mediterranean Cuisine",
      location: "Portimão, Algarve"
    },
    menu: {
      title: "Our Menu",
      badge: "— Gastronomy —",
      subtitle: "Flavors that celebrate the Mediterranean",
      viewAll: "View Full Menu",
      available: "Available",
      unavailable: "Unavailable",
      noImage: "Photo coming soon"
    },
    gallery: {
      title: "Gallery",
      badge: "— Moments —",
      subtitle: "Our story in images",
      empty: "Gallery coming soon"
    },
    location: {
      title: "Find Us",
      badge: "— Location —",
      address: "Address",
      hours: "Opening Hours",
      contact: "Contact",
      directions: "Get Directions",
      call: "Call Now",
      reserve: "Book a Table"
    },
    footer: {
      rights: "All rights reserved",
      reserve: "Book a Table",
      links: "Links",
      contact: "Contact",
      social: "Social Media"
    },
    admin: {
      login: "Admin Login",
      email: "Email",
      password: "Password",
      loginBtn: "Sign In",
      loggingIn: "Signing in...",
      logout: "Sign Out",
      dashboard: "Dashboard",
      content: "Content",
      menu: "Menu",
      gallery: "Gallery",
      settings: "Settings",
      save: "Save",
      saving: "Saving...",
      saved: "Saved!",
      cancel: "Cancel",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      upload: "Upload image",
      uploading: "Uploading...",
      confirmDelete: "Are you sure you want to delete this?",
      portuguese: "Portuguese",
      english: "English",
      heroSection: "Hero Section",
      aboutSection: "About the Restaurant",
      heroTitle: "Hero Title",
      heroSubtitle: "Hero Subtitle",
      heroImage: "Hero Image",
      aboutTitle: "About Title",
      aboutText: "About Text",
      aboutImage: "About Image",
      categories: "Categories",
      dishes: "Dishes",
      categoryName: "Category Name",
      dishName: "Dish Name",
      description: "Description",
      price: "Price (€)",
      category: "Category",
      available: "Available",
      featured: "Featured",
      dishImage: "Dish Photo",
      addCategory: "New Category",
      addDish: "New Dish",
      editCategory: "Edit Category",
      editDish: "Edit Dish",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Hours",
      reservationUrl: "Reservation Link",
      mapsEmbed: "Google Maps Embed URL",
      logoHeader: "Header Logo",
      logoFooter: "Footer Logo",
      socialFacebook: "Facebook URL",
      socialInstagram: "Instagram URL",
      socialTripadvisor: "TripAdvisor URL",
      seoTitle: "SEO Title",
      seoDescription: "SEO Description",
      seoKeywords: "SEO Keywords",
      contactInfo: "Contact Information",
      socialMedia: "Social Media",
      seoSettings: "SEO",
      logos: "Logos",
      stats: "Statistics",
      totalDishes: "Dishes",
      totalCategories: "Categories",
      totalGallery: "Gallery",
      welcomeBack: "Welcome back",
      imageCaption: "Caption (optional)",
      order: "Order",
      galleryCaption: "Image Caption"
    }
  }
};

export default translations;
